import React from "react";
import OrdersPage from "Common/Components/OrdersPage";

// سفارش‌های در انبار = سفارش‌هایی که order_status آن‌ها in_warehouse است.
// سرور این وضعیت را فقط وقتی می‌دهد که همه قلم‌ها وارد انبار شده باشند، بنابراین
// پیشروی لجستیک از صفحه‌ی اقلام انجام می‌شود؛ این صفحه فقط وضعیت سفارش را نشان می‌دهد.
const Index = () => (
  <OrdersPage
    pageTitle="سفارش‌های در انبار"
    orderStatus="in_warehouse"
    emptyText="هیچ سفارشی در انبار نیست"
  />
);

export default Index;
